(function(){
  const root = document.querySelector('.moo-configurator[data-config-id]');
  if(!root) return;
  if(root.dataset.mooInit === '1') return;
  root.dataset.mooInit = '1';
  const jsonId = root.getAttribute('data-config-id');
  const cfgEl = document.getElementById(jsonId);
  if(!cfgEl){ root.style.display='none'; return; }
  let cfg={};
  try{ cfg=JSON.parse(cfgEl.textContent||'{}'); }catch(e){ cfg={}; }
  const minW=Number(cfg.minW||0), maxW=Number(cfg.maxW||0), minL=Number(cfg.minL||0), maxL=Number(cfg.maxL||0);
  const tiers=Array.isArray(cfg.tiers)?cfg.tiers.map(n=>Number(n||0)):[];
  const dimsOk=minW>0&&maxW>0&&minL>0&&maxL>0&&maxW>=minW&&maxL>=minL;
  const tiersOk=tiers.length===5&&tiers.every(v=>Number.isFinite(v)&&v>0);
  if(!dimsOk||!tiersOk){
    root.style.display='none';
    const optSec=document.querySelector('.moo-options');
    if(optSec) optSec.style.display='none';
    return;
  }
  const widthEl=root.querySelector('#moo-width'), lengthEl=root.querySelector('#moo-length');
  const outSurface=document.getElementById('moo-surface');
  const outTier=document.getElementById('moo-tier-price');
  const outTotal=document.getElementById('moo-total');
  const outGrandTotal=document.getElementById('moo-grand-total');
  const summaryBlock=document.getElementById('moo-summary-block');
  const recapDims=document.getElementById('moo-recap-dims');
  const recapEpaisseur=document.getElementById('moo-recap-epaisseur');
  const recapChant=document.getElementById('moo-recap-chant');
  const recapChantRow=document.getElementById('moo-recap-chant-row');
  const recapDecor2=document.getElementById('moo-recap-decor2');
  const recapDecor2Row=document.getElementById('moo-recap-decor2-row');
  const recapRouleau=document.getElementById('moo-recap-rouleau');
  const recapRouleauRow=document.getElementById('moo-recap-rouleau-row');
  const recapAssemLinDroit=document.getElementById('moo-recap-assem-lin-droit');
  const recapAssemLinDroitRow=document.getElementById('moo-recap-assem-lin-droit-row');
  const recapAssemLinGauche=document.getElementById('moo-recap-assem-lin-gauche');
  const recapAssemLinGaucheRow=document.getElementById('moo-recap-assem-lin-gauche-row');
  const recapAssemAngDroit=document.getElementById('moo-recap-assem-ang-droit');
  const recapAssemAngDroitRow=document.getElementById('moo-recap-assem-ang-droit-row');
  const recapAssemAngGauche=document.getElementById('moo-recap-assem-ang-gauche');
  const recapAssemAngGaucheRow=document.getElementById('moo-recap-assem-ang-gauche-row');
  const recapCoupePan=document.getElementById('moo-recap-coupe-pan');
  const recapCoupePanRow=document.getElementById('moo-recap-coupe-pan-row');
  const recapCoupeQuart=document.getElementById('moo-recap-coupe-quart');
  const recapCoupeQuartRow=document.getElementById('moo-recap-coupe-quart-row');
  const recapCoupeArc=document.getElementById('moo-recap-coupe-arc');
  const recapCoupeArcRow=document.getElementById('moo-recap-coupe-arc-row');
  const recapCoupeQuartInt=document.getElementById('moo-recap-coupe-quartint');
  const recapCoupeQuartIntRow=document.getElementById('moo-recap-coupe-quartint-row');
  const recapCoupePana=document.getElementById('moo-recap-coupe-pana');
  const recapCoupePanaRow=document.getElementById('moo-recap-coupe-pana-row');
  const recapOptions=document.getElementById('moo-recap-options');
  const recapOptionsRow=document.getElementById('moo-recap-options-row');
  const widthRange=root.querySelector('#moo-width-range'), lengthRange=root.querySelector('#moo-length-range');
  if(!widthEl||!lengthEl) return;
  widthEl.min=String(minW); widthEl.max=String(maxW); lengthEl.min=String(minL); lengthEl.max=String(maxL);
  if(widthRange) widthRange.innerHTML='Min <strong>'+minW+'</strong> • Max <strong>'+maxW+'</strong>';
  if(lengthRange) lengthRange.innerHTML='Min <strong>'+minL+'</strong> • Max <strong>'+maxL+'</strong>';
  const round2=n=>Math.round((n+Number.EPSILON)*100)/100;
  const fmt2FR=n=>round2(n).toFixed(2).replace('.',',');
  const fmtM2FR=n=>(Math.round(n*1000)/1000).toFixed(3).replace('.',',');
  function getTierIndex(area){
    const a=Math.round(area*1000)/1000;
    if(a<=0.10) return 0; if(a<=0.20) return 1; if(a<=0.30) return 2; if(a<=0.50) return 3; return 4;
  }
  function findField(sA,sB){ return document.querySelector(sA)||document.querySelector(sB); }
  function field1(){ return findField('.calc-field[data-name="field_1"] input[name="field_1"]','input[name="field_1"]'); }
  function field2(){ return findField('.calc-field[data-name="field_2"] input[name="field_2"]','input[name="field_2"]'); }
  function field3(){ return findField('.calc-field[data-name="field_3"] input[name="field_3"]','input[name="field_3"]'); }
  function field4(){ return findField('.calc-field[data-name="field_4"] input[name="field_4"]','input[name="field_4"]'); }
  function setInputValue(el,val){ if(!el) return; const newVal = val == null ? '' : String(val); if(el.value === newVal) return; el.value=newVal; el.dispatchEvent(new Event('input',{bubbles:true})); el.dispatchEvent(new Event('change',{bubbles:true})); }
  function findAddToCartForm(){
    const direct = root.closest('form[action*="/cart/add"]');
    if(direct) return direct;
    const section = root.closest('[id*="shopify-section"]');
    if(section){
      const mainForm = section.querySelector('product-form.main-product-form form[action*="/cart/add"]')
        || section.querySelector('form.main-product-form[action*="/cart/add"]')
        || section.querySelector('form[action*="/cart/add"]:not(.installment):not(.form)');
      if(mainForm) return mainForm;
    }
    const candidates = document.querySelectorAll('form[action*="/cart/add"]');
    for(const f of candidates){
      const inQuickview = f.closest('[id*="quickview"], [id*="quick-view"]');
      const inCartDrawer = f.closest('[id*="cart-drawer"], [id*="cart-notification"]');
      const isInstallment = f.classList.contains('installment');
      const isQuickAdd = f.classList.contains('form') && f.closest('product-form.quick-add');
      if(!inQuickview && !inCartDrawer && !isInstallment && !isQuickAdd){
        return f;
      }
    }
    return null;
  }
  const propCache=new Map();
  function ensureProperty(name,value){
    const form=findAddToCartForm(); if(!form) return;
    let input=propCache.get(name);
    if(!input||!input.isConnected){ input=document.createElement('input'); input.type='hidden'; input.name='properties['+name+']'; form.appendChild(input); propCache.set(name,input); }
    input.value=value==null?'':String(value);
  }

  let rouleauQty = 0;
  let assemLinDroitQty = 0;
  let assemLinGaucheQty = 0;
  let assemAngDroitQty = 0;
  let assemAngGaucheQty = 0;
  let coupePanQty = 0;
  let coupeQuartQty = 0;
  let coupeArcQty = 0;
  let coupeQuartIntQty = 0;
  let coupePanaQty = 0;
  document.addEventListener('click', function(e){
    if(e.target.id === 'moo-rouleau-plus'){ rouleauQty++; document.getElementById('moo-rouleau-qty').textContent = rouleauQty; update(); }
    if(e.target.id === 'moo-rouleau-moins'){ if(rouleauQty > 0) rouleauQty--; document.getElementById('moo-rouleau-qty').textContent = rouleauQty; update(); }
    if(e.target.id === 'moo-assem-lin-droit-plus'){ assemLinDroitQty++; document.getElementById('moo-assem-lin-droit-qty').textContent = assemLinDroitQty; update(); }
    if(e.target.id === 'moo-assem-lin-droit-moins'){ if(assemLinDroitQty > 0) assemLinDroitQty--; document.getElementById('moo-assem-lin-droit-qty').textContent = assemLinDroitQty; update(); }
    if(e.target.id === 'moo-assem-lin-gauche-plus'){ assemLinGaucheQty++; document.getElementById('moo-assem-lin-gauche-qty').textContent = assemLinGaucheQty; update(); }
    if(e.target.id === 'moo-assem-lin-gauche-moins'){ if(assemLinGaucheQty > 0) assemLinGaucheQty--; document.getElementById('moo-assem-lin-gauche-qty').textContent = assemLinGaucheQty; update(); }
    if(e.target.id === 'moo-assem-ang-droit-plus'){ assemAngDroitQty++; document.getElementById('moo-assem-ang-droit-qty').textContent = assemAngDroitQty; update(); }
    if(e.target.id === 'moo-assem-ang-droit-moins'){ if(assemAngDroitQty > 0) assemAngDroitQty--; document.getElementById('moo-assem-ang-droit-qty').textContent = assemAngDroitQty; update(); }
    if(e.target.id === 'moo-assem-ang-gauche-plus'){ assemAngGaucheQty++; document.getElementById('moo-assem-ang-gauche-qty').textContent = assemAngGaucheQty; update(); }
    if(e.target.id === 'moo-assem-ang-gauche-moins'){ if(assemAngGaucheQty > 0) assemAngGaucheQty--; document.getElementById('moo-assem-ang-gauche-qty').textContent = assemAngGaucheQty; update(); }
    if(e.target.id === 'moo-coupe-pan-plus'){ coupePanQty++; document.getElementById('moo-coupe-pan-qty').textContent = coupePanQty; update(); }
    if(e.target.id === 'moo-coupe-pan-moins'){ if(coupePanQty > 0) coupePanQty--; document.getElementById('moo-coupe-pan-qty').textContent = coupePanQty; update(); }
    if(e.target.id === 'moo-coupe-quart-plus'){ coupeQuartQty++; document.getElementById('moo-coupe-quart-qty').textContent = coupeQuartQty; update(); }
    if(e.target.id === 'moo-coupe-quart-moins'){ if(coupeQuartQty > 0) coupeQuartQty--; document.getElementById('moo-coupe-quart-qty').textContent = coupeQuartQty; update(); }
    if(e.target.id === 'moo-coupe-arc-plus'){ coupeArcQty++; document.getElementById('moo-coupe-arc-qty').textContent = coupeArcQty; update(); }
    if(e.target.id === 'moo-coupe-arc-moins'){ if(coupeArcQty > 0) coupeArcQty--; document.getElementById('moo-coupe-arc-qty').textContent = coupeArcQty; update(); }
    if(e.target.id === 'moo-coupe-quartint-plus'){ coupeQuartIntQty++; document.getElementById('moo-coupe-quartint-qty').textContent = coupeQuartIntQty; update(); }
    if(e.target.id === 'moo-coupe-quartint-moins'){ if(coupeQuartIntQty > 0) coupeQuartIntQty--; document.getElementById('moo-coupe-quartint-qty').textContent = coupeQuartIntQty; update(); }
    if(e.target.id === 'moo-coupe-pana-plus'){ coupePanaQty++; document.getElementById('moo-coupe-pana-qty').textContent = coupePanaQty; update(); }
    if(e.target.id === 'moo-coupe-pana-moins'){ if(coupePanaQty > 0) coupePanaQty--; document.getElementById('moo-coupe-pana-qty').textContent = coupePanaQty; update(); }
  });

  function getOptionsTotal(area){
    const epaisseurEl=document.querySelector('input[name="moo-epaisseur"]:checked');
    const epaisseurVal=epaisseurEl?Number(epaisseurEl.value):0;
    const epaisseurLabel=epaisseurEl?epaisseurEl.getAttribute('data-label'):'38mm';
    const chantEl=document.querySelector('input[name="moo-chant"]:checked');
    const chantVal=chantEl?Number(chantEl.value):0;
    const chantLabel=chantEl?chantEl.getAttribute('data-label'):'Chant avant uniquement';
    const rouleauVal=round2(rouleauQty*14.90);
    const assemLinDroitVal=round2(assemLinDroitQty*99.90);
    const assemLinGaucheVal=round2(assemLinGaucheQty*99.90);
    const assemAngDroitVal=round2(assemAngDroitQty*149.90);
    const assemAngGaucheVal=round2(assemAngGaucheQty*149.90);
    const coupePanVal=round2(coupePanQty*79.90);
    const coupeQuartVal=round2(coupeQuartQty*89.90);
    const coupeArcVal=round2(coupeArcQty*179.90);
    const coupeQuartIntVal=round2(coupeQuartIntQty*89.90);
    const coupePanaVal=round2(coupePanaQty*89.90);
    const decor2El=document.querySelector('input[name="moo-decor2"]:checked');
    const decor2Active=decor2El?decor2El.value==='1':false;
    const decor2Val=decor2Active?round2((area||0)*79):0;
    return{epaisseurVal,epaisseurLabel,chantVal,chantLabel,rouleauVal,assemLinDroitVal,assemLinGaucheVal,assemAngDroitVal,assemAngGaucheVal,coupePanVal,coupeQuartVal,coupeArcVal,coupeQuartIntVal,coupePanaVal,decor2Active,decor2Val,total:round2(epaisseurVal+chantVal+rouleauVal+assemLinDroitVal+assemLinGaucheVal+assemAngDroitVal+assemAngGaucheVal+coupePanVal+coupeQuartVal+coupeArcVal+coupeQuartIntVal+coupePanaVal+decor2Val)};
  }

  let lastW=null,lastL=null,lastArea=null,lastTotal=null,lastTierLabel=null,lastPriceM2=null;
  function resetUI(){
    if(summaryBlock) summaryBlock.style.display='none';
  }
  function clearAll(){
    widthEl.value=''; lengthEl.value='';
    lastW=lastL=lastArea=lastTotal=lastTierLabel=lastPriceM2=null;
    rouleauQty=0; assemLinDroitQty=0; assemLinGaucheQty=0; assemAngDroitQty=0; assemAngGaucheQty=0;
    coupePanQty=0; coupeQuartQty=0; coupeArcQty=0; coupeQuartIntQty=0; coupePanaQty=0;
    const qtyEl=document.getElementById('moo-rouleau-qty');
    if(qtyEl) qtyEl.textContent='0';
    const aLD=document.getElementById('moo-assem-lin-droit-qty'); if(aLD) aLD.textContent='0';
    const aLG=document.getElementById('moo-assem-lin-gauche-qty'); if(aLG) aLG.textContent='0';
    const aAD=document.getElementById('moo-assem-ang-droit-qty'); if(aAD) aAD.textContent='0';
    const aAG=document.getElementById('moo-assem-ang-gauche-qty'); if(aAG) aAG.textContent='0';
    const cP=document.getElementById('moo-coupe-pan-qty'); if(cP) cP.textContent='0';
    const cQ=document.getElementById('moo-coupe-quart-qty'); if(cQ) cQ.textContent='0';
    const cA=document.getElementById('moo-coupe-arc-qty'); if(cA) cA.textContent='0';
    const cQI=document.getElementById('moo-coupe-quartint-qty'); if(cQI) cQI.textContent='0';
    const cPa=document.getElementById('moo-coupe-pana-qty'); if(cPa) cPa.textContent='0';
    resetUI();
    setInputValue(field1(),''); setInputValue(field2(),''); setInputValue(field3(),''); setInputValue(field4(),'');
    ensureProperty('Largeur (mm)',''); ensureProperty('Longueur (mm)',''); ensureProperty('Dimensions','');
    ensureProperty('Surface (m²)',''); ensureProperty('Tarif appliqué (€/m²)',''); ensureProperty('Tranche','');
    ensureProperty('Prix calculé (€)',''); ensureProperty('Configuration','');
    ensureProperty('Épaisseur',''); ensureProperty('Chant',''); ensureProperty('Bande rouleau','');
    ensureProperty('Assemblage linéaire droit','');
    ensureProperty('Assemblage linéaire gauche','');
    ensureProperty('Assemblage d\'angle droit','');
    ensureProperty('Assemblage d\'angle gauche','');
    ensureProperty('Pan coupé','');
    ensureProperty('1/4 de rond','');
    ensureProperty('Arc de cercle','');
    ensureProperty('1/4 de rond intérieur','');
    ensureProperty('Pan avancé','');
    ensureProperty('Supplément options (€)',''); ensureProperty('Prix total (€)','');
  }
  function pushExternal(){
    const opts=getOptionsTotal(lastArea);
    const grandTotal=lastTotal!=null?round2(lastTotal+opts.total):null;
    if(grandTotal!=null) setInputValue(field1(),grandTotal.toFixed(2));
    if(lastW!=null&&lastL!=null) setInputValue(field2(),lastW+'mm x '+lastL+'mm');
    setInputValue(field3(), opts.epaisseurLabel);
    setInputValue(field4(), opts.chantLabel);
  }
  function update(){
    const wRaw=widthEl.value, lRaw=lengthEl.value;
    if(!wRaw||!lRaw){ lastW=lastL=lastArea=lastTotal=lastTierLabel=lastPriceM2=null; resetUI(); return; }
    const w=parseInt(wRaw,10), l=parseInt(lRaw,10);
    if(!wRaw||!lRaw){ lastW=lastL=lastArea=lastTotal=lastTierLabel=lastPriceM2=null; resetUI(); return; }
    const wErr=document.getElementById('moo-width-error');
    const lErr=document.getElementById('moo-length-error');
    let widthValid=true, lengthValid=true;
    if(w<minW){ wErr.textContent='⚠ Largeur minimum : '+minW+' mm'; wErr.style.display='block'; widthEl.classList.add('is-invalid'); widthValid=false; }
    else if(w>maxW){ wErr.textContent='⚠ Largeur maximum : '+maxW+' mm'; wErr.style.display='block'; widthEl.classList.add('is-invalid'); widthValid=false; }
    else { wErr.style.display='none'; widthEl.classList.remove('is-invalid'); }
    if(l<minL){ lErr.textContent='⚠ Longueur minimum : '+minL+' mm'; lErr.style.display='block'; lengthEl.classList.add('is-invalid'); lengthValid=false; }
    else if(l>maxL){ lErr.textContent='⚠ Longueur maximum : '+maxL+' mm'; lErr.style.display='block'; lengthEl.classList.add('is-invalid'); lengthValid=false; }
    else { lErr.style.display='none'; lengthEl.classList.remove('is-invalid'); }
    const atcForm_v=findAddToCartForm();
    const atcBtn=atcForm_v?atcForm_v.querySelector('button[type="submit"]'):null;
    if(atcBtn){ if(!widthValid||!lengthValid){ atcBtn.disabled=true; atcBtn.style.opacity='0.5'; atcBtn.style.cursor='not-allowed'; } else { atcBtn.disabled=false; atcBtn.style.opacity=''; atcBtn.style.cursor=''; } }
    if(!widthValid||!lengthValid){ resetUI(); return; }
    const area=(w*l)/1000000;
    const idx=getTierIndex(area);
    const priceM2=Number(tiers[idx]||0);
    if(priceM2<=0) return;
    const total=Math.max(59.90, round2(area*priceM2));
    const opts=getOptionsTotal(area);
    const grandTotal=round2(total+opts.total);

    if(summaryBlock) summaryBlock.style.display='block';
    if(outSurface) outSurface.textContent=fmtM2FR(area);
    if(outTier) outTier.textContent=fmt2FR(priceM2);
    if(outTotal) outTotal.textContent=fmt2FR(total);
    if(outGrandTotal) outGrandTotal.textContent=fmt2FR(grandTotal);
    if(recapDims) recapDims.textContent=w+' × '+l+' mm';
    if(recapEpaisseur) recapEpaisseur.textContent=opts.epaisseurLabel+(opts.epaisseurVal>0?' (+'+fmt2FR(opts.epaisseurVal)+' €)':'');

    if(opts.chantVal>0){
      if(recapChant) recapChant.textContent=opts.chantLabel+' (+'+fmt2FR(opts.chantVal)+' €)';
      if(recapChantRow) recapChantRow.style.display='flex';
    } else {
      if(recapChantRow) recapChantRow.style.display='none';
    }

    if(opts.decor2Active){
      if(recapDecor2) recapDecor2.textContent='Oui (+'+fmt2FR(opts.decor2Val)+' €)';
      if(recapDecor2Row) recapDecor2Row.style.display='flex';
    } else { if(recapDecor2Row) recapDecor2Row.style.display='none'; }

    if(assemLinDroitQty>0){
      if(recapAssemLinDroit) recapAssemLinDroit.textContent=assemLinDroitQty+' pièce'+(assemLinDroitQty>1?'s':'')+' (+'+fmt2FR(opts.assemLinDroitVal)+' €)';
      if(recapAssemLinDroitRow) recapAssemLinDroitRow.style.display='flex';
    } else { if(recapAssemLinDroitRow) recapAssemLinDroitRow.style.display='none'; }

    if(assemLinGaucheQty>0){
      if(recapAssemLinGauche) recapAssemLinGauche.textContent=assemLinGaucheQty+' pièce'+(assemLinGaucheQty>1?'s':'')+' (+'+fmt2FR(opts.assemLinGaucheVal)+' €)';
      if(recapAssemLinGaucheRow) recapAssemLinGaucheRow.style.display='flex';
    } else { if(recapAssemLinGaucheRow) recapAssemLinGaucheRow.style.display='none'; }

    if(assemAngDroitQty>0){
      if(recapAssemAngDroit) recapAssemAngDroit.textContent=assemAngDroitQty+' pièce'+(assemAngDroitQty>1?'s':'')+' (+'+fmt2FR(opts.assemAngDroitVal)+' €)';
      if(recapAssemAngDroitRow) recapAssemAngDroitRow.style.display='flex';
    } else { if(recapAssemAngDroitRow) recapAssemAngDroitRow.style.display='none'; }

    if(assemAngGaucheQty>0){
      if(recapAssemAngGauche) recapAssemAngGauche.textContent=assemAngGaucheQty+' pièce'+(assemAngGaucheQty>1?'s':'')+' (+'+fmt2FR(opts.assemAngGaucheVal)+' €)';
      if(recapAssemAngGaucheRow) recapAssemAngGaucheRow.style.display='flex';
    } else { if(recapAssemAngGaucheRow) recapAssemAngGaucheRow.style.display='none'; }

    if(coupePanQty>0){
      if(recapCoupePan) recapCoupePan.textContent=coupePanQty+' pièce'+(coupePanQty>1?'s':'')+' (+'+fmt2FR(opts.coupePanVal)+' €)';
      if(recapCoupePanRow) recapCoupePanRow.style.display='flex';
    } else { if(recapCoupePanRow) recapCoupePanRow.style.display='none'; }

    if(coupeQuartQty>0){
      if(recapCoupeQuart) recapCoupeQuart.textContent=coupeQuartQty+' pièce'+(coupeQuartQty>1?'s':'')+' (+'+fmt2FR(opts.coupeQuartVal)+' €)';
      if(recapCoupeQuartRow) recapCoupeQuartRow.style.display='flex';
    } else { if(recapCoupeQuartRow) recapCoupeQuartRow.style.display='none'; }

    if(coupeArcQty>0){
      if(recapCoupeArc) recapCoupeArc.textContent=coupeArcQty+' pièce'+(coupeArcQty>1?'s':'')+' (+'+fmt2FR(opts.coupeArcVal)+' €)';
      if(recapCoupeArcRow) recapCoupeArcRow.style.display='flex';
    } else { if(recapCoupeArcRow) recapCoupeArcRow.style.display='none'; }

    if(coupeQuartIntQty>0){
      if(recapCoupeQuartInt) recapCoupeQuartInt.textContent=coupeQuartIntQty+' pièce'+(coupeQuartIntQty>1?'s':'')+' (+'+fmt2FR(opts.coupeQuartIntVal)+' €)';
      if(recapCoupeQuartIntRow) recapCoupeQuartIntRow.style.display='flex';
    } else { if(recapCoupeQuartIntRow) recapCoupeQuartIntRow.style.display='none'; }

    if(coupePanaQty>0){
      if(recapCoupePana) recapCoupePana.textContent=coupePanaQty+' pièce'+(coupePanaQty>1?'s':'')+' (+'+fmt2FR(opts.coupePanaVal)+' €)';
      if(recapCoupePanaRow) recapCoupePanaRow.style.display='flex';
    } else { if(recapCoupePanaRow) recapCoupePanaRow.style.display='none'; }

    if(rouleauQty>0){
      if(recapRouleau) recapRouleau.textContent=rouleauQty+' rouleau'+(rouleauQty>1?'x':'')+' (+'+fmt2FR(opts.rouleauVal)+' €)';
      if(recapRouleauRow) recapRouleauRow.style.display='flex';
    } else { if(recapRouleauRow) recapRouleauRow.style.display='none'; }

    if(opts.total>0){
      if(recapOptions) recapOptions.textContent='+'+fmt2FR(opts.total)+' €';
      if(recapOptionsRow) recapOptionsRow.style.display='flex';
    } else { if(recapOptionsRow) recapOptionsRow.style.display='none'; }

    lastW=w; lastL=l; lastArea=area; lastTotal=total;
    lastTierLabel='tier_'+String(idx+1).padStart(2,'0');
    lastPriceM2=priceM2;
    pushExternal();

    ensureProperty('Largeur (mm)',w); ensureProperty('Longueur (mm)',l);
    ensureProperty('Dimensions',w+'mm x '+l+'mm');
    ensureProperty('Surface (m²)',(Math.round(area*1000)/1000).toFixed(3));
    ensureProperty('Tarif appliqué (€/m²)',round2(priceM2).toFixed(2));
    ensureProperty('Tranche',lastTierLabel);
    ensureProperty('Prix calculé (€)',round2(total).toFixed(2));
    ensureProperty('Épaisseur',opts.epaisseurLabel);
    ensureProperty('Chant',opts.chantVal>0?opts.chantLabel:'Chant avant uniquement');
    ensureProperty('Décor 2 faces',opts.decor2Active?'Oui (+'+fmt2FR(opts.decor2Val)+' €)':'');
    ensureProperty('Bande rouleau',rouleauQty>0?'Bande de chant en rouleau 1m · '+rouleauQty+' rouleau'+(rouleauQty>1?'x':''):'');
    ensureProperty('Assemblage linéaire droit',assemLinDroitQty>0?'Assemblage linéaire droit · '+assemLinDroitQty+' pièce'+(assemLinDroitQty>1?'s':''):'');
    ensureProperty('Assemblage linéaire gauche',assemLinGaucheQty>0?'Assemblage linéaire gauche · '+assemLinGaucheQty+' pièce'+(assemLinGaucheQty>1?'s':''):'');
    ensureProperty('Assemblage d\'angle droit',assemAngDroitQty>0?'Assemblage d\'angle droit · '+assemAngDroitQty+' pièce'+(assemAngDroitQty>1?'s':''):'');
    ensureProperty('Assemblage d\'angle gauche',assemAngGaucheQty>0?'Assemblage d\'angle gauche · '+assemAngGaucheQty+' pièce'+(assemAngGaucheQty>1?'s':''):'');
    ensureProperty('Pan coupé',coupePanQty>0?'Pan coupé · '+coupePanQty+' pièce'+(coupePanQty>1?'s':''):'');
    ensureProperty('1/4 de rond',coupeQuartQty>0?'1/4 de rond · '+coupeQuartQty+' pièce'+(coupeQuartQty>1?'s':''):'');
    ensureProperty('Arc de cercle',coupeArcQty>0?'Arc de cercle · '+coupeArcQty+' pièce'+(coupeArcQty>1?'s':''):'');
    ensureProperty('1/4 de rond intérieur',coupeQuartIntQty>0?'1/4 de rond intérieur · '+coupeQuartIntQty+' pièce'+(coupeQuartIntQty>1?'s':''):'');
    ensureProperty('Pan avancé',coupePanaQty>0?'Pan avancé · '+coupePanaQty+' pièce'+(coupePanaQty>1?'s':''):'');
    ensureProperty('Supplément options (€)',opts.total>0?round2(opts.total).toFixed(2):'0');
    ensureProperty('Prix total (€)',grandTotal.toFixed(2));
    ensureProperty('Configuration','L='+w+'mm × l='+l+'mm • '+(Math.round(area*1000)/1000).toFixed(3)+' m² • Ép. '+opts.epaisseurLabel+' • Total '+grandTotal.toFixed(2)+'€');
  }
  widthEl.addEventListener('input',update);
  lengthEl.addEventListener('input',update);
  document.querySelectorAll('input[name="moo-epaisseur"]').forEach(el=>el.addEventListener('change',update));
  document.querySelectorAll('input[name="moo-chant"]').forEach(el=>el.addEventListener('change',update));
  document.querySelectorAll('input[name="moo-decor2"]').forEach(el=>el.addEventListener('change',update));
  const retry=setInterval(()=>{ if(lastW!=null||lastTotal!=null||lastArea!=null) pushExternal(); },300);
  setTimeout(()=>clearInterval(retry),12000);
  function isVariantUI(el){
    if(!el) return false;
    const configSection = root.closest('[id*="shopify-section"]');
    const elSection = el.closest ? el.closest('[id*="shopify-section"]') : null;
    if(configSection && elSection && configSection !== elSection) return false;
    if(el.closest && el.closest('[id*="quickview"], [id*="quick-view"], [id*="cart-drawer"], [id*="cart-notification"]')) return false;
    if(el.name==='id') return true;
    if(el.matches&&el.matches('select[name="id"],input[name="id"]')) return true;
    if(el.closest&&el.closest('variant-selects,variant-radios,.variant-picker,.product-form__input')) return true;
    if(el.matches&&el.matches('select[name^="options"],input[name^="options"]')) return true;
    return false;
  }
  root.__mooClearAll = clearAll;
  root.__mooIsVariantUI = isVariantUI;
  if(!window.__mooConfiguratorGlobalListeners){
    window.__mooConfiguratorGlobalListeners = true;
    document.addEventListener('change', function(e){
      document.querySelectorAll('.moo-configurator[data-config-id]').forEach(function(r){
        var isVar = r.__mooIsVariantUI, clr = r.__mooClearAll;
        if(typeof isVar === 'function' && typeof clr === 'function' && isVar(e.target)){
          clr(); setTimeout(clr, 80);
        }
      });
    }, true);
    document.addEventListener('variant:change', function(){
      document.querySelectorAll('.moo-configurator[data-config-id]').forEach(function(r){
        var clr = r.__mooClearAll;
        if(typeof clr === 'function'){ clr(); setTimeout(clr, 80); }
      });
    }, true);
  }
  const atcForm=findAddToCartForm();
  if(atcForm){ atcForm.addEventListener('submit',function(){ update(); pushExternal(); },true); }

  var _hasUserInteracted = false;
  function showVariantChangeNotice(){
    var notice = document.getElementById('moo-variant-change-notice');
    if (!notice) return;
    notice.style.display = 'flex';
    if (notice._hideTimer) clearTimeout(notice._hideTimer);
    notice._hideTimer = setTimeout(function(){ notice.style.display = 'none'; }, 5000);
  }
  function hideVariantChangeNotice(){
    var notice = document.getElementById('moo-variant-change-notice');
    if (!notice) return;
    notice.style.display = 'none';
    if (notice._hideTimer) { clearTimeout(notice._hideTimer); notice._hideTimer = null; }
  }
  if (widthEl) widthEl.addEventListener('input', function(){ _hasUserInteracted = true; hideVariantChangeNotice(); });
  if (lengthEl) lengthEl.addEventListener('input', function(){ _hasUserInteracted = true; hideVariantChangeNotice(); });
  function _mooMaybeShowNotice(){
    if (_hasUserInteracted) setTimeout(showVariantChangeNotice, 200);
  }
  document.addEventListener('change', function(e){
    if (typeof isVariantUI === 'function' && isVariantUI(e.target)) _mooMaybeShowNotice();
  }, true);
  document.addEventListener('variant:change', _mooMaybeShowNotice, true);
  resetUI(); update();
  (function(){
    var lastResolvedTitle = null;

    function findCurrentVariantId(){
      var variantsList = window.MPROD_VARIANTS_CACHE || [];
      if (!variantsList.length) return null;
      var validIds = {};
      for (var i = 0; i < variantsList.length; i++){
        validIds[String(variantsList[i].id)] = variantsList[i];
      }
      var inputs = document.querySelectorAll('input[name="id"]');
      var matches = [];
      for (var j = 0; j < inputs.length; j++){
        var inp = inputs[j];
        if (inp.closest('[id*="quickview"], [id*="quick-view"], [id*="cart-drawer"], [id*="cart-notification"]')) continue;
        var section = inp.closest('[id*="shopify-section"]');
        if (section && /quickview|cart-drawer|cart-notification/i.test(section.id)) continue;
        var form = inp.closest('form');
        if (form && form.classList.contains('installment')) continue;
        var inMainForm = form && form.classList.contains('main-product-form');
        var inMainSection = section && /__main$/.test(section.id);
        if (!inMainForm && !inMainSection) continue;
        if (inp.value && validIds[String(inp.value)]){
          matches.push({ value: inp.value, variant: validIds[String(inp.value)], inMainForm: inMainForm });
        }
      }
      if (!matches.length) return null;
      for (var k = 0; k < matches.length; k++){
        if (matches[k].inMainForm) return matches[k];
      }
      return matches[0];
    }

    function updateRecapRef(){
      var recapRef = document.getElementById('moo-recap-ref');
      if (!recapRef) return;
      var match = findCurrentVariantId();
      var title = match ? (match.variant.option1 || match.variant.title || '') : '';
      if (title && title !== lastResolvedTitle){
        lastResolvedTitle = title;
        recapRef.textContent = title;
      } else if (!title && lastResolvedTitle === null){
        recapRef.textContent = '—';
      }
    }

    updateRecapRef();
    setInterval(updateRecapRef, 500);

    ['change', 'variant:change', 'on:variant:change', 'product:variant-change'].forEach(function(evt){
      document.addEventListener(evt, function(){ setTimeout(updateRecapRef, 50); }, true);
    });

    document.addEventListener('click', function(e){
      if (e.target && e.target.closest && e.target.closest('.swatch-input, [class*="swatch"], .product-form__input--swatch, [data-option-value]')){
        setTimeout(updateRecapRef, 100);
        setTimeout(updateRecapRef, 400);
      }
    }, true);
  })();
})();

document.addEventListener('click',function(e){
  const trigger=e.target.closest('.product-card-variant-js');
  if(!trigger) return;
  const widthEl=document.querySelector('#moo-width'), lengthEl=document.querySelector('#moo-length');
  if(widthEl) widthEl.value='';
  if(lengthEl) lengthEl.value='';
  const summaryBlock=document.getElementById('moo-summary-block');
  if(summaryBlock) summaryBlock.style.display='none';
});

(function(){
  var ALLOWED_CART_KEYS = [
    'Dimensions',
    'Épaisseur',
    'Chant',
    'Décor 2 faces',
    'Assemblage linéaire droit',
    'Assemblage linéaire gauche',
    "Assemblage d'angle droit",
    "Assemblage d'angle gauche",
    'Pan coupé',
    '1/4 de rond',
    'Arc de cercle',
    '1/4 de rond intérieur',
    'Pan avancé',
    'Bande rouleau',
    'Label',
    '__ooCustomPrice',
    '__ooCalcPayload',
    '__ooLiteSig',
    '__ooDraftToken',
    '__ooQuotedPrice',
    '__ooPayloadHash',
    '_data'
  ];

  var REMOVE_IF_EMPTY = [
    'Décor 2 faces',
    'Assemblage linéaire droit',
    'Assemblage linéaire gauche',
    "Assemblage d'angle droit",
    "Assemblage d'angle gauche",
    'Pan coupé',
    '1/4 de rond',
    'Arc de cercle',
    '1/4 de rond intérieur',
    'Pan avancé',
    'Bande rouleau'
  ];

  var _origFetch = window.fetch;
  window.fetch = function(url, opts){
    try {
      if (typeof url === 'string' && url.indexOf('/cart/add') !== -1 && opts && opts.body instanceof FormData) {
        var keysToDelete = [];
        opts.body.forEach(function(value, key){
          var match = key.match(/^properties\[(.+)\]$/);
          if (!match) return;
          var propName = match[1];
          if (ALLOWED_CART_KEYS.indexOf(propName) === -1) {
            keysToDelete.push(key);
            return;
          }
          if (REMOVE_IF_EMPTY.indexOf(propName) !== -1 && (value == null || String(value).trim() === '')) {
            keysToDelete.push(key);
          }
        });
        keysToDelete.forEach(function(k){ opts.body.delete(k); });
      }
    } catch(e) { /* silent */ }
    return _origFetch.apply(this, arguments);
  };
})();